<script>
import Table from '@ohmsd/v-table';
import { defaultSort, Worker } from '@ohmsd/v-table/utils';

import { onAppear } from 'services/appear';

export { defaultSort, Worker };

export default {
  extends: Table,

  mounted () {
    const $pager = document.createElement('div');
    $pager.classList.add('__pager');

    this._offPager = onAppear(
      $pager,
      () => this.page++,
      { once: false },
    );

    this.$el.append($pager);
  },

  unmounted () {
    this._offPager();
  },

  props: {
    per: { type: Number, default: 50 },
  },
};

</script>
<style lang="postcss">
.Table__wrapper {
  .__pager {
    position: relative;
    top: -500px;

    pointer-events: none;
  }
}
</style>
